import { useState, useEffect } from "react";
import "../styles/Settings.css";
import SocialMedia from "./SocialMedia";
import OpeningHours from "./OpeningHours";
import Location from "./Location";
import Maintanance from "./Maintanance";
import Notifications from './Notifications';
import GeneralInfo from './GeneralInfo';
import Colors from './Colors';
import Delivery from './Delivery';
import Feedback from '../common/components/Feedback';

function Settings() {
    const [activeButton, setActiveButton] = useState(""); // State to track active button

    const handleButtonClick = (buttonName) => {
        setActiveButton(buttonName); // Set the clicked button as active
    };

    const generalInfo = "General";
    const contactUs = "Contact";
    const openingHours = "Business Hours";
    const location = 'Location';
    const maintanance = "Maintenance";
    const notifications = "Notifications";
    const colors = "Theme";
    const delivery = "Delivery";

    // Set the default active button on initial render
    useEffect(() => {
        handleButtonClick(generalInfo);
    }, []); // Empty dependency array ensures this runs only once

    return (
        <div className="settings">
            <div className="settings-buttons">
                    <button
                        className={`settings-button ${activeButton === generalInfo ? "active" : ""}`}
                        onClick={() => handleButtonClick(generalInfo)}
                    >
                        {generalInfo}
                    </button>
                    <button
                        className={`settings-button ${activeButton === contactUs ? "active" : ""}`}
                        onClick={() => handleButtonClick(contactUs)}
                    >
                        {contactUs}
                    </button>
                    <button
                        className={`settings-button ${activeButton === openingHours ? "active" : ""}`}
                        onClick={() => handleButtonClick(openingHours)}
                    >
                        {openingHours}
                    </button>
                    <button
                        className={`settings-button ${activeButton === location ? "active" : ""}`}
                        onClick={() => handleButtonClick(location)}
                    >
                        {location}
                    </button>
                    <button
                        className={`settings-button ${activeButton === maintanance ? "active" : ""}`}
                        onClick={() => handleButtonClick(maintanance)}
                    >
                        {maintanance}
                    </button>
                    <button
                        className={`settings-button ${activeButton === delivery ? "active" : ""}`}
                        onClick={() => handleButtonClick(delivery)}
                    >
                        {delivery}
                    </button>
                    <button
                        className={`settings-button ${activeButton === notifications ? "active" : ""}`}
                        onClick={() => handleButtonClick(notifications)}
                    >
                        {notifications}
                    </button>
                    <button
                        className={`settings-button ${activeButton === colors ? "active" : ""}`}
                        onClick={() => handleButtonClick(colors)}
                    >
                        {colors}
                    </button>
                </div>

                {activeButton === contactUs && <SocialMedia />}
                {activeButton === openingHours && <OpeningHours />}
                {activeButton === location && <Location />}
                {activeButton === maintanance && <Maintanance/>}
                {activeButton === notifications && <Notifications />}
                {activeButton === generalInfo && <GeneralInfo />}
                {activeButton === colors && <Colors />}
                {activeButton === delivery && <Delivery />}
                
                {/* Feedback system available on all settings pages */}
                <Feedback />
            </div>
    );
}

export default Settings;